import React from "react";
import Modal from "./Modal";

const ConfirmDeleteModal = ({
  isOpen,
  title = "Confirm Delete",
  message = "Are you sure you want to delete this item?",
  onConfirm,
  onCancel,
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false,
}) => (
  <Modal
    isOpen={isOpen}
    title={title}
    maxWidthClass="max-w-sm"
    footer={
      <>
        <button
          className="px-4 py-2 rounded-md text-sm font-medium border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-60"
          onClick={onCancel}
          disabled={loading}
        >
          {cancelText}
        </button>
        <button
          className="px-6 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-400"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Deleting..." : confirmText}
        </button>
      </>
    }
  >
    <p className="text-sm text-gray-600 text-center">{message}</p>
  </Modal>
);

export default ConfirmDeleteModal;
